import { cn } from '@/lib/utils';
import { Image, ImagePlugin, useMediaState } from '@platejs/media/react';
import { ResizableProvider } from '@platejs/resizable';
import type { TImageElement } from 'platejs';
import type { PlateElementProps } from 'platejs/react';
import { PlateElement, withHOC } from 'platejs/react';
import { MediaToolbar } from './media-popover';
import { mediaResizeHandleVariants, Resizable, ResizeHandle } from './resizable';

export const ImageElement = withHOC(ResizableProvider, function ImageElement(props: PlateElementProps<TImageElement>) {
  const { align = 'center', focused, readOnly, selected } = useMediaState();

  return (
    <MediaToolbar plugin={ImagePlugin}>
      <PlateElement {...props} className="py-2.5">
        <figure className="group relative m-0" contentEditable={false}>
          <Resizable
            align={align}
            options={{
              align,
              readOnly,
            }}
          >
            <ResizeHandle
              className={mediaResizeHandleVariants({ direction: 'left' })}
              options={{ direction: 'left' }}
            />
            <Image
              className={cn(
                'block w-full max-w-full cursor-pointer object-cover px-0',
                'rounded-sm',
                focused && selected && 'ring-ring ring-2 ring-offset-2',
              )}
              alt={props.attributes.alt as string | undefined}
            />
            <ResizeHandle
              className={mediaResizeHandleVariants({
                direction: 'right',
              })}
              options={{ direction: 'right' }}
            />
          </Resizable>
        </figure>

        {props.children}
      </PlateElement>
    </MediaToolbar>
  );
});
